import * as GrayTheme from './gray'

export default GrayTheme
